import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE } from '@rci/storage/local-storage.service';
import { v4 as uuid } from 'uuid';
import {
  REALM,
  X_APP_NAME_HEADER,
  X_APP_NAME_HEADER_VALUE,
  X_TRANSACTION_ID_HEADER,
} from '@rci/self-serve-fido/app.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    @Inject(LOCAL_STORAGE) private readonly localStorage: Storage,
    private readonly translateService: TranslateService,
  ) {}

  getDomainServiceHeaders(language?: string) {
    return {
      language: language ? language : this.translateService.currentLang,
      realm: REALM,
      [X_APP_NAME_HEADER]: X_APP_NAME_HEADER_VALUE,
      [X_TRANSACTION_ID_HEADER]: uuid(),
    };
  }
}
